<template>
  <div id="app">
    <header class="app-header">
      <div class="app-logo">FoodToge</div>
      <el-menu
        mode="horizontal"
        :router="true"
        :default-active="menuActive"
      >
        <el-menu-item index="/recipes">菜谱管理</el-menu-item>
        <el-menu-item index="/generate">自动配菜</el-menu-item>
        <el-menu-item index="/history">历史菜单</el-menu-item>
      </el-menu>
    </header>
    <main class="app-main">
      <keep-alive include="RecipeManage,MenuGenerate,HistoryMenus">
        <router-view/>
      </keep-alive>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    menuActive() {
      if (this.$route.path.indexOf('/history') === 0) return '/history'
      return this.$route.path
    }
  }
}
</script>
